import * as schemas from "./schemas";
import { CLIENT_TOKEN } from "shadow-client";
import { HydraActions } from "shadow-client/redux";
import { HydraClient } from "shadow-client/axios";

// files
const fileClient = new HydraClient(`/${CLIENT_TOKEN}/files`);
const fileActions = new HydraActions(schemas.file);

export const fetchFile = (identifier, config, ...args) => dispatch => {
  const fileConfig = {
    ...config
  };

  const sendRequest = fileClient.fetchEntity(identifier, fileConfig, ...args);

  return sendRequest.then(response => {
    const fileEntity = {
      "@id": identifier,
      type: response.headers["content-type"], // https://developer.mozilla.org/en-US/docs/Web/API/Blob/type
      name: response.headers["X-Stadline-Content-Name"] || "", // https://developer.mozilla.org/en-US/docs/Web/API/File/name
      content: response.data
    };

    return dispatch(fileActions.receiveEntity(fileEntity));
  });
};



// WEBPACK FOOTER //
// ./src/shadow-client/endpoints/fileApi/index.js